import { supabase } from '../config/supabase';

interface Profile {
  id: string;
  role: string;
  full_name: string;
  org_id: string;
  created_at: string;
}

export const profileService = {
  // Get the current user's profile
  async getCurrentUserProfile(): Promise<Profile | null> {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return null;

      const { data: profile, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', user.id)
        .single();

      if (error) throw error;
      return profile;
    } catch (error) {
      console.error('Error fetching user profile:', error);
      return null;
    }
  },

  // Get user's role
  async getUserRole(): Promise<string | null> {
    try {
      const profile = await this.getCurrentUserProfile();
      return profile?.role || null;
    } catch (error) {
      console.error('Error fetching user role:', error);
      return null;
    }
  },

  // Check if user has a specific role
  async hasRole(requiredRole: string): Promise<boolean> {
    try {
      const role = await this.getUserRole();
      return role === requiredRole;
    } catch (error) {
      console.error('Error checking user role:', error);
      return false;
    }
  },

  // Get profile by ID
  async getProfileById(id: string): Promise<Profile | null> {
    try {
      const { data: profile, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', id)
        .single();

      if (error) throw error;
      return profile;
    } catch (error) {
      console.error('Error fetching profile by ID:', error);
      return null;
    }
  }
}; 